import script from "./AdditionalService.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalService.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalService.vue?vue&type=style&index=0&id=6c2920db&lang=scss"

const __exports__ = script;

export default __exports__